import CryptoJs from 'crypto-js';

export function determineDefaultAvatarForUser(
  name: string,
  email: string
): string {
  const emailSha = CryptoJs.enc.Hex.stringify(CryptoJs.SHA1(email));
  const emailMd5 = CryptoJs.enc.Hex.stringify(CryptoJs.MD5(email));
  const initials = name
    .split(' ')
    .map((it) => [...it][0])
    .join(``);

  return `https://www.gravatar.com/avatar/${emailMd5}?d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/${initials}/128/${emailSha.slice(0, 6)}`;
}
